const EmailSaved = (props) => (
  <svg
    width="155"
    height="152"
    viewBox="0 0 155 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8456_8278)">
      <path
        d="M77.2184 126.531C110.018 126.531 136.618 100.131 136.618 67.5312C136.618 34.9313 110.018 8.53125 77.2184 8.53125C44.4184 8.53125 17.8184 34.9313 17.8184 67.5312C17.8184 100.131 44.4184 126.531 77.2184 126.531Z"
        fill="#EAEEF9"
      />
      <path
        d="M135.1 39.3309C137.365 39.3309 139.2 37.4953 139.2 35.2309C139.2 32.9666 137.365 31.1309 135.1 31.1309C132.836 31.1309 131 32.9666 131 35.2309C131 37.4953 132.836 39.3309 135.1 39.3309Z"
        fill="#EAEEF9"
      />
      <path
        d="M131.001 26.0316C132.547 26.0316 133.801 24.778 133.801 23.2316C133.801 21.6852 132.547 20.4316 131.001 20.4316C129.454 20.4316 128.201 21.6852 128.201 23.2316C128.201 24.778 129.454 26.0316 131.001 26.0316Z"
        fill="#EAEEF9"
      />
      <path
        d="M17.6003 35.2309C19.1467 35.2309 20.4003 33.9773 20.4003 32.4309C20.4003 30.8845 19.1467 29.6309 17.6003 29.6309C16.0539 29.6309 14.8003 30.8845 14.8003 32.4309C14.8003 33.9773 16.0539 35.2309 17.6003 35.2309Z"
        fill="#EAEEF9"
      />
      <path
        d="M11.3006 96.8316C14.1725 96.8316 16.5006 94.5035 16.5006 91.6316C16.5006 88.7597 14.1725 86.4316 11.3006 86.4316C8.4287 86.4316 6.10059 88.7597 6.10059 91.6316C6.10059 94.5035 8.4287 96.8316 11.3006 96.8316Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_8456_8278)">
        <path
          d="M131.944 52.9243V107.065C131.944 107.288 131.944 107.4 131.944 107.623C131.832 110.749 130.381 113.428 128.148 115.326C126.25 117 123.683 118.116 120.892 118.116H33.4858C31.5881 118.116 29.802 117.67 28.2392 116.777C27.5694 116.442 26.8996 115.995 26.3415 115.437C25.1136 114.433 23.9973 112.981 23.4391 111.418C22.9926 110.302 22.6577 109.074 22.6577 107.846V52.9243C22.6577 52.9243 27.2345 49.0172 33.8207 43.659C40.6302 37.9658 49.5606 30.5982 57.3747 24.1237C61.8399 20.3282 61.3934 20.7748 68.3144 14.97C73.5611 10.5048 81.2635 10.5048 86.5102 14.97C87.8497 16.0863 89.3009 17.4259 90.6405 18.5422C93.5429 20.8864 96.6685 23.5655 100.017 26.3563C107.05 32.1611 114.753 38.6356 120.781 43.659C126.92 48.6823 131.385 52.4777 131.944 52.9243Z"
          fill="url(#paint0_linear_8456_8278)"
        />
      </g>
      <path
        d="M120.78 43.5477V62.9713L101.692 74.4692L95.9985 77.9298L83.9424 85.1857L78.2493 88.6463L75.7934 90.0974L73.4492 88.6463L68.0909 85.1857L56.593 77.9298L51.2348 74.4692L33.5972 63.4178V43.6593C40.4066 37.9661 49.337 30.5985 57.1512 24.124L99.9055 26.245C107.05 32.1614 114.752 38.5243 120.78 43.5477Z"
        fill="#989FB0"
      />
      <path
        d="M116.985 28.1426V62.3014L99.5708 72.683L94.4358 75.8086L83.3844 82.2832L78.2494 85.4088L76.0168 86.6368L73.8958 85.4088L68.9841 82.2832L58.4909 75.8086L53.5791 72.683L37.5044 62.6363V28.1426C37.5044 24.5704 40.4068 21.668 44.0906 21.668H110.399C113.971 21.5564 116.985 24.5704 116.985 28.1426Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M23.104 52.7012L75.5702 56.1618L131.162 52.7012L129.041 62.6363C129.041 62.6363 76.7981 89.8741 77.133 89.8741C77.4679 89.8741 23.2157 57.613 23.2157 57.613L23.104 52.7012Z"
        fill="url(#paint1_linear_8456_8278)"
      />
      <path
        d="M131.944 52.9238V107.623C131.832 110.749 130.381 113.428 128.148 115.326C126.25 117 123.683 118.116 120.892 118.116H33.4858C31.5881 118.116 29.802 117.67 28.2392 116.777C27.5694 116.442 26.8996 115.995 26.3415 115.437C25.1136 114.432 23.9973 112.981 23.4391 111.418C22.9926 110.302 22.6577 109.074 22.6577 107.846V107.735V52.9238L71.5517 83.5104L75.7937 86.1896L77.2449 85.2965L78.5844 84.5151L131.944 52.9238Z"
        fill="#738DFF"
      />
      <path
        d="M128.26 115.326C126.362 117 123.795 118.116 121.004 118.116H33.4858C31.5881 118.116 29.802 117.67 28.2392 116.777C27.5694 116.442 26.8996 115.995 26.3415 115.437C25.1136 114.432 23.9973 112.981 23.4391 111.418C22.9926 110.302 22.6577 109.074 22.6577 107.846V107.735V52.9238L28.3508 56.3843L77.2449 85.2965L78.5844 86.0779L78.696 86.1896L122.567 112.088L128.26 115.326Z"
        fill="url(#paint2_linear_8456_8278)"
      />
      <path
        d="M78.5843 84.4038V88.1992L28.2391 116.777C27.5693 116.442 26.8995 115.995 26.3413 115.437C25.1134 114.433 23.9971 112.981 23.439 111.419L72.4446 82.3945L76.6866 85.0736L77.2447 85.2968L78.5843 84.4038Z"
        fill="url(#paint3_linear_8456_8278)"
      />
      <path
        d="M22.6577 52.9238L77.2449 85.2965"
        stroke="white"
        stroke-miterlimit="10"
      />
      <path
        d="M131.943 52.9238V107.623C131.832 110.749 130.381 113.428 128.148 115.326C126.25 117 123.683 118.116 120.892 118.116H33.4856C31.5879 118.116 29.8018 117.67 28.239 116.777C27.5692 116.442 26.8995 115.995 26.3413 115.437L31.9228 112.088L75.7935 86.1896L77.2447 85.2965L78.5842 84.5151L126.139 56.2727L131.943 52.9238Z"
        fill="url(#paint4_linear_8456_8278)"
      />
      <path
        d="M131.943 52.9238L78.5842 84.4035L77.2447 85.2965L75.7935 86.1896L26.3413 115.326"
        stroke="white"
        stroke-miterlimit="10"
      />
      <path
        d="M118.771 91.2137H89.7474C89.0777 91.2137 88.5195 90.6555 88.5195 89.9857C88.5195 89.316 89.0777 88.7578 89.7474 88.7578H118.771C119.441 88.7578 119.999 89.316 119.999 89.9857C120.111 90.6555 119.553 91.2137 118.771 91.2137Z"
        fill="#CED7E2"
      />
      <path
        d="M118.771 99.5857H89.7474C89.0777 99.5857 88.5195 99.0276 88.5195 98.3578C88.5195 97.688 89.0777 97.1299 89.7474 97.1299H118.771C119.441 97.1299 119.999 97.688 119.999 98.3578C120.111 99.0276 119.553 99.5857 118.771 99.5857Z"
        fill="#CED7E2"
      />
      <path
        d="M124.799 117L128.371 115.214C128.26 115.326 128.26 115.326 128.148 115.437C128.148 115.437 128.148 115.437 128.036 115.437L124.799 117Z"
        fill="#526DFF"
      />
      <path
        d="M74.451 64.3462C73.5859 64.3462 72.7716 64.0283 72.1099 63.3393L60.8625 51.6273C59.5901 50.3024 59.5901 48.0766 60.8625 46.7517C62.1348 45.4268 64.2723 45.4268 65.5447 46.7517L74.451 56.0259L95.4192 34.2447C96.6915 32.9198 98.8291 32.9198 100.101 34.2447C101.374 35.5696 101.374 37.7954 100.101 39.1203L76.7921 63.3393C76.1814 64.0283 75.3162 64.3462 74.451 64.3462Z"
        fill="#15B097"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8456_8278"
        x="0.657715"
        y="0.621094"
        width="153.287"
        height="150.495"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8456_8278"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8456_8278"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_8456_8278"
        x1="77.2569"
        y1="12.8695"
        x2="77.2569"
        y2="92.3603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8456_8278"
        x1="77.085"
        y1="101.659"
        x2="77.085"
        y2="55.2062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8A90B5" />
        <stop offset="1" stop-color="#A7AED2" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8456_8278"
        x1="75.4244"
        y1="51.4158"
        x2="75.4244"
        y2="118.819"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8456_8278"
        x1="54.1606"
        y1="102.734"
        x2="49.8801"
        y2="96.4691"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D5D8E4" />
        <stop offset="1" stop-color="#E1E4F0" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8456_8278"
        x1="79.108"
        y1="51.4158"
        x2="79.108"
        y2="118.819"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <clipPath id="clip0_8456_8278">
        <rect
          width="154"
          height="151"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmailSaved;
